export const LOGIN_SUCCESS          = 'login_success';
export const LOGIN_FAIL             = 'login_fail';
export const LOGOUT                 = 'logout';

export const CREATE_USER_SUCCESS    = 'create_user_success';
export const CREATE_USER_FAIL       = 'create_user_fail';



// WEBPACK FOOTER //
// ./src/actions/types.js